import { IGeometryModel, MarkerModelBase } from "@types-custom/models/business/marker.model";
import { Icon } from "@types-custom/models/ui/icon-model";

export enum ParkingLinesEnum {
  GREEN_ZONE = 'greenZone',
  BLUE_ZONE = 'blueZone',
  LOAD_ZONE = 'forLoadUnload',
  DISABLED_ZONE = 'forDisabled',
}

export interface IPropsParkingLineModel {
  id: string;
  type: string;
  availableSpotNumber: number;
  category: string;
  occupiedSpotNumber: number;
  totalSpotNumber: number;
  name: string;
  maximumParkingDuration: string;
  markerPopupText: string;
}

export class ParkingLineModel extends MarkerModelBase {
  static className = 'ParkingLineModel';
  classProperties: IPropsParkingLineModel;

  constructor(props: IPropsParkingLineModel, geometry: IGeometryModel) {
    super(geometry, ParkingLineModel.className);
    this.classProperties = props;
  }
}

export interface IPropsPanicButtonModel {
  id: number;
  deviceId: string;
  establishment: string;
  address: string;
  phone: string;
  registerDate: string;
  creationDate: string;
  title?: string;
  markerPopupText?: string;
  icon: Icon;
}

export class PanicButtonModel extends MarkerModelBase {
  static className = 'PanicButtonModel';
  classProperties: IPropsPanicButtonModel;

  constructor(props: IPropsPanicButtonModel, geometry: IGeometryModel) {
    super(geometry, PanicButtonModel.className);
    this.classProperties = props;
  }
}
